import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, Subscription} from 'rxjs';
import {Stock, IStock} from '../../shared/model/stock.model';
import {StockService} from './stock.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Transaction} from '../../shared/model/transaction.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {Customer} from '../../shared/model/customer.model';
import {Organization} from "../../shared/model/organization.model";
import * as moment from 'jalali-moment';
import {EventService} from "../../singelton/event.service";


@Component({
  selector: 'app-stock-update',
  templateUrl: './stock-update.component.html',
  styleUrls: ['../order/order-add.component.scss']
})
export class StockUpdateComponent implements OnInit {
  stock: IStock = new Stock();
  isSaving: boolean;
  @Input() stockEdit;
  @Input() transactionId;
  @Input() customerId;
  strDateObject: any;


  currentAccount: any;
  stocks: IStock[];
  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  closeResult: string;
  showForm = false;
  commentObject: IStock = new Stock();

  constructor(protected stockService: StockService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal,
              protected eventService: EventService,
              private spinner: NgxSpinnerService) {
    this.itemsPerPage = 20;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';

  }

  ngOnInit() {
    this.isSaving = false;
// alert(' in init ==' + this.stockEdit);
    if (this.stockEdit) {
      this.stockService.find(this.stockEdit).subscribe(
        (res: HttpResponse<IStock>) => {
          this.stock = res.body;
          if (this.stock.alarm_point_date_str) {
            const jalaliDate5 = moment(this.stock.alarm_point_date_str).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
            this.strDateObject = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
          }

          // alert(this.stock);
          // alert(this.stock.alarm_point_count);
          // alert(this.stock.order_point_count);
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
    if (this.customerId) {
      this.showForm = true;
    }
    if (this.transactionId) {
      this.loadAll();
    }
    // this.activatedRoute.data.subscribe(({stock}) => {
    //   this.stock = stock;
    // });
  }

  loadAll() {
    // this.stockService
    //   .query({
    //     page: this.page - 1,
    //     size: this.itemsPerPage,
    //     sort: this.sort(this.predicate, this.reverse)
    //   })
    //   .subscribe(
    //     (res: HttpResponse<IStock[]>) => this.paginateStocks(res.body, res.headers),
    //     (res: HttpErrorResponse) => this.onError(res.message)
    //   );
    if (this.transactionId) {
      this.spinner.show();
    }
    this.stockService.findStockTransaction(
      this.transactionId).subscribe(
      (res: HttpResponse<IStock[]>) => {
        this.stocks = res.body;
        this.spinner.hide();

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  sort(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }


  protected paginateStocks(data: IStock[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.stocks = data;
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }

  save() {
    this.isSaving = true;
    if (this.customerId) {
      // this.stock.customer = new Customer(this.customerId);
    }
    const span_strDate = document.getElementById('span_strDate');
    if (span_strDate) {
      this.stock.alarm_point_date_str = (<HTMLInputElement>span_strDate).innerHTML;
      if (this.stock.alarm_point_date_str === '') {
        this.stock.alarm_point_date_str = null;
        this.stock.alarm_point_date = null;
      }
    } else {
      this.stock.alarm_point_date_str = null;
      this.stock.alarm_point_date = null;
    }

    this.stock.organization = new Organization(1);

    // this.stock.organization = new Organization(1);
    if (this.stock.id !== undefined) {
      this.subscribeToSaveResponse(this.stockService.update(this.stock));
    } else {
      this.subscribeToSaveResponse(this.stockService.create(this.stock));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IStock>>) {
    result.subscribe((res: HttpResponse<IStock>) => this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess(res) {

    this.isSaving = false;
    // this.activeModal.dismiss('cancel');
    this.stock =res.body;
    this.showForm = false;
    this.loadAll();
    // if(this.customerId) {
    this.clear();
    this.eventService.onResponseStock('test message 22');

    // }
    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  addComment() {
    this.showForm = true;
    this.stock = new Stock();
  }

  clearForm() {
    this.showForm = false;
    this.activeModal.dismiss('cancel');
  }

  clear() {
    this.showForm = false;
    this.activeModal.dismiss(this.stock);
  }


}
